import { Box } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";

const MolliePaymentSkeleton = (): JSX.Element => (
  <Box height={300} width={"100%"}>
    <Skeleton />
  </Box>
);

export default MolliePaymentSkeleton;
